import { capitalize } from 'lodash-es';
import { LinkKind } from '@care/navigation/dist/components/GlobalNavIA/NavLinkList/NavLinkList';
import { seoNavigationLinkSection_seoNavigationLinkSection_SEONavigationLinkSectionSuccess_seoNavigationLinkSection_childCareLinks as SEONavigationLink } from '@/__generated__/seoNavigationLinkSection';

const titleMap: Record<string, string> = Object.freeze({
  Jobs: 'All jobs',
  'Hospice care': 'Hospice support',
  'Dog daycare': 'Doggy day care',
  'Move out cleaning services': 'Move-in/move-out cleaning',
  'House cleaners': 'House cleaning',
});

/**
 *
 *  Converts a SEO navigation link item to a LinkKind type.
 *  This function takes a base URL and a navigation link item, and returns an object
 *  that conforms to the LinkKind type used in the navigation menu.
 *  @param baseURL - The base URL to prepend to the link.
 *  @param navigationLinkItem - The navigation link item to map.
 *  @param linkType - The type of link, either 'primary' or 'secondary'.
 *  @returns An object representing the LinkKind type.
 */

export const convertSeoNavLinkToVgnLink = (
  baseURL: string,
  navigationLinkItem: SEONavigationLink,
  linkType: 'primary' | 'secondary'
): LinkKind => {
  const title = capitalize(navigationLinkItem.title);
  const finalTitle = titleMap[title] ?? title;
  const isActivitiesAndCamps = finalTitle === 'Activities & camps';
  const id = finalTitle.toLowerCase().replace(/\s+/g, '-');

  return {
    id,
    value: finalTitle,
    href: `${baseURL}${navigationLinkItem.urlPath}`,
    kind: 'link',
    linkType,
    ...(isActivitiesAndCamps && { tag: 'New' }),
  };
};
